import countries from 'i18n-iso-countries'
import countriesEn from 'i18n-iso-countries/langs/en.json'
import languages from '@/constants/languages'

const DEFAULT_LOCALE = 'en'
const locales = Object.create(null)
Object.entries(languages).forEach(([iso]) => {
  if (iso.length > 2 || iso === DEFAULT_LOCALE) {
    return
  }

  locales[iso] = () => import(
    /* webpackChunkName: "i18n-iso-countries/[request]" */
    `i18n-iso-countries/langs/${iso}.json`
  )
})
countries.registerLocale(countriesEn)

export default {
  countries,
  data() {
    return {
      i18nIsoCountries: [DEFAULT_LOCALE]
    }
  },
  methods: {
    country(iso) {
      let { locale } = this.$i18n
      if (!this.i18nIsoCountries.includes(locale)) {
        locale = DEFAULT_LOCALE
      }
      return this.$options.countries.getName(iso, locale)
    }
  },
  watch: {
    locale(locale) {
      const loadedLocales = this.i18nIsoCountries
      if (!loadedLocales.includes(locale)) {
        locales[locale]().then((data) => {
          countries.registerLocale(data)
          loadedLocales.push(locale)
        })
      }
    }
  }
}
